import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form__set form__set--wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "h5 h5--b" }, " Project Deliverables ", -1 /* HOISTED */)
const _hoisted_5 = { class: "h5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "light"
}
const _hoisted_8 = { class: "light" }
const _hoisted_9 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.currency,
          type: "select",
          "input-id": "currency",
          name: "currency",
          label: "Currency",
          options: $setup.currencies,
          required: true,
          errors: $setup.form_errors.currency || null,
          "onUpdate:value": _cache[0] || (_cache[0] = new_value => $setup.form_fields.currency = new_value)
        }, null, 8 /* PROPS */, ["value", "options", "errors"])
      ]),
      ($setup.scope)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _createElementVNode("h3", _hoisted_5, [
              ($setup.scope.sequence_prefix)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.scope.sequence_prefix) + "  ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.scope.sequence_prefix)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " —  "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_8, _toDisplayString($setup.scope.title), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scope.items, (item, index) => {
              return (_openBlock(), _createBlock($setup["ProjectDeliverableComponent"], {
                key: 'scope-item' + index,
                deliverable: item,
                currency: $setup.selected_currency
              }, null, 8 /* PROPS */, ["deliverable", "currency"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", _hoisted_9, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2)
  ]))
}